// Approximates UIKit's own spring for banner notifications (a snappy
// settle with a small, barely-visible overshoot rather than a soft ease) —
// tuned to resolve in ~0.4s. Also used by the auth backdrop's push demo and
// the campaign composer's Korza Studio preview, so every notification
// arrives with the same feel.
export const NOTIFICATION_ENTRANCE_TRANSITION = {
  type: 'spring' as const,
  stiffness: 420,
  damping: 28,
  mass: 0.9,
};
